import script from "./DisdiLocationDetailsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisdiLocationDetailsTab.vue?vue&type=script&setup=true&lang=ts"

import "./DisdiLocationDetailsTab.vue?vue&type=style&index=0&id=6c5932ac&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5932ac"]])

export default __exports__